import React from 'react';
import { SectionHeading } from './SectionHeading';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Since working with Smart Market Digital, our organic traffic has increased by 200% in just 6 months. The leads are high quality and consistent.',
  author: 'Sarah Jenkins',
  role: 'Marketing Director, TechFlow UK',
  initial: 'S'
}, {
  quote: 'The team is incredibly responsive and knowledgeable. They completely revamped our PPC campaigns and lowered our cost per acquisition significantly.',
  author: 'David Miller',
  role: 'Founder, Miller & Co',
  initial: 'D'
}, {
  quote: "Professional, transparent, and results-oriented. They don't just talk about vanity metrics, they focus on what actually drives revenue for our business.",
  author: 'James Wilson',
  role: 'CEO, Urban Logistics',
  initial: 'J'
}];
export function Testimonials() {
  return <section id="testimonials" className="py-20 bg-slate-50" data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <SectionHeading title="What Our Clients Say" subtitle="Success Stories" data-id="element-111" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-112">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col" data-id="element-113">
              <div className="flex gap-1 mb-6" data-id="element-114">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-115" />)}
              </div>
              <p className="text-slate-600 mb-8 flex-grow italic" data-id="element-116">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-117">
                <div className="w-12 h-12 bg-slate-900 rounded-full flex items-center justify-center text-white font-bold text-xl" data-id="element-118">
                  {testimonial.initial}
                </div>
                <div data-id="element-119">
                  <h4 className="font-bold text-slate-900" data-id="element-120">
                    {testimonial.author}
                  </h4>
                  <p className="text-sm text-slate-500" data-id="element-121">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}